module.exports = __webpack_public_path__ + "media/images/icons/flags/VE-75ab561f7cbddcb5350fd9716ee09587.svg";